<template>
  <div>
    <div class="row">
      <div class="col-md-12 col-md-offset-1">
        <div class="card card-wizard" id="wizardCard">
          <form-wizard ref="wizard" error-color="#EB5E28" color="#1e94fd" title="Activos" subtitle="" @on-complete="siguente" @on-change="cancelAll">
            <tab-content title="Bienes Inmuebles (Situación actual)" icon="ti-home">
              <bienes-inmuebles ref="BienesInmuebles"></bienes-inmuebles>
            </tab-content>
            <tab-content title="Vehículos (Situación actual)" icon="ti-car">
              <bienes-muebles ref="BienesMuebles"></bienes-muebles>
            </tab-content>
            <tab-content title="Bienes Muebles (Situación actual)" icon="ti-money">
              <bienes-muebles-n-r ref="BienesMueblesNR"></bienes-muebles-n-r>
            </tab-content>
            <tab-content title="Inversiones, cuentas bancarias y otro tipo de valores / activos (Situación actual)" icon="ti-stats-up">
              <inversiones ref="Inversiones"></inversiones>
            </tab-content>

            <button slot="prev" class="btn btn-default btn-fill btn-wd btn-back">Atrás</button>
            <button slot="next" class="btn btn-info btn-fill btn-wd btn-next">Siguiente</button>
            <button slot="finish" class="btn btn-info btn-fill btn-wd btn-next">Siguiente</button><!-- @click="siguente()" -->
          </form-wizard>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    FormWizard,
    TabContent
  } from 'vue-form-wizard'
  import 'vue-form-wizard/dist/vue-form-wizard.min.css'
  import BienesInmuebles from './Formularios/Activos/BienesInmuebles.vue'
  import BienesMuebles from './Formularios/Activos/BienesMuebles.vue'
  import BienesMueblesNR from './Formularios/Activos/BienesMueblesNR.vue'
  import Inversiones from './Formularios/Activos/Inversiones.vue'
  /* import EfectivoMetales from './Formularios/Activos/EfectivoMetales.vue'
  import Fideicomisos from './Formularios/Activos/Fideicomisos.vue'
  import BienesIntangibles from './Formularios/Activos/BienesIntangibles.vue'
  import CuentasCobrar from './Formularios/Activos/CuentasCobrar.vue'
  import UsoBeneficios from './Formularios/Activos/UsoBeneficios.vue'*/
  import swal from 'sweetalert2'
  export default {
    data() {
      return {
        wizardModel: {}
      }
    },
    components: {
      FormWizard,
      TabContent,
      BienesInmuebles,
      BienesMuebles,
      BienesMueblesNR,
      Inversiones,
      /*EfectivoMetales,
       Fideicomisos,
      BienesIntangibles,
      CuentasCobrar,
      UsoBeneficios*/
    },
    watch: {
      '$route': 'checkPermissions'
    },
    methods: {
      checkPermissions() {
        // && this.getKey('grupo') != 3
        if (!(this.getKey('role') == 0 && this.getKey('status_dec') == 1)) {
          localStorage.clear();
          this.$router.push('/login');
          this.$router.go();
        }
      },
      cancelAll() {
        var tab = this.$refs.wizard.tabs[this.$refs.wizard.activeTabIndex].$children;
        tab[0].cancelEdit();
      },
      siguente() {
        this.$router.push('pasivos');
      },
    },
    created() {
      this.checkPermissions()
    },
    mounted() {
      this.$refs.wizard.activateAll();
    }
  }

</script>
<style>
  .vue-form-wizard .wizard-icon-circle.tab_shape {
    background-color: #9A9A9A !important;
    color: white;
  }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Forms/Activos.vue